////////////////////productpage insta section//////////////////////////////////////////
  /*****************Fixed Scroll On Homepage *************/
$(document).ready(function() {
  if ($(window).width() < 749) {
    $('.instaslider').slick({
    dots: false,
   centerMode: true,
   centerPadding: '60px',
   slidesToShow: 1,
  slidesToScroll: 1,
       autoplay: true,
  autoplaySpeed: 2000,
    prevArrow: false,
    nextArrow: false
});
  }
  else{
  $('.instaslider').slick({
    dots: false,
    centerMode: true,
        centerPadding: '60px',
   slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    prevArrow: false,
    nextArrow: false,
     responsive: [
          {
            breakpoint: 1400,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 4
            }
          },
           {
            breakpoint: 1024,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 2.2
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 1.2
            }
          }
        ]
});
  }
    });


//////////////////this code for copy discount code to clipboard////////////////////////////

// ///////<h6 class="gf_gs-text-heading-2">
//   <span style="color: rgb(170, 63, 34); font-weight: bold;">&nbsp;Use Discount Code&nbsp;</span>: 
//   <font color="#000000">
//     <b id="discount-code" style="cursor: pointer; position: relative;" onclick="copyToClipboard()">
//       TWIN30
//       <span id="tooltip" style="visibility: hidden; background-color: black; color: #fff; text-align: center; border-radius: 4px; padding: 5px; position: absolute; z-index: 1; bottom: 100%; left: 50%; transform: translateX(-50%); font-size: 12px;">
//         Copied
//       </span>
//     </b>
//   </font>
// </h6>
///////////////////
  function copyToClipboard() {
    const code = document.getElementById('discount-code').innerText;
    navigator.clipboard.writeText(code).then(() => {
      const tooltip = document.getElementById('tooltip');
      tooltip.style.visibility = 'visible';
      setTimeout(() => {
        tooltip.style.visibility = 'hidden';
      }, 1500); 
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }